import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";

const EventWrapper = tw.div`my-4`;
const EventTitle = tw.div`block text-gray-900 leading-tight`;
const EventTitleLink = tw.a`block text-blue-900 hocus:text-blue-700 leading-tight`;
const EventDate = tw.div`text-xs tracking-wide`;
const EventLocation = tw.div`text-xs tracking-wide`;

const Event = ({ title, date, location, href }) => (
  <EventWrapper>
    {href ? (
      <EventTitleLink href={href}>{title}</EventTitleLink>
    ) : (
      <EventTitle>{title}</EventTitle>
    )}
    {date && <EventDate>{date}</EventDate>}
    {location && <EventLocation>{location}</EventLocation>}
  </EventWrapper>
);

Event.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  location: PropTypes.string,
  href: PropTypes.string
};

export default Event;
